import React, { useState, useMemo } from "react";
import { InputField } from "components/InputField";
import { MyCheckbox } from "components/MyCheckbox";
import InfoTooltip from "components/InfoTooltip";
// direct import
import { checkboxes } from "./helper";

// one hint per checkbox; "\u2011" is a non-breaking hyphen so "non‑members" never wraps
const CHECKBOX_HINTS = {
  catagory_is_organization: "Organizations can be assigned this account category.",
  catagory_is_member: "Individual members can be assigned this account category.",
  catagory_is_not_member: "Non\u2011members can be assigned this account category.",
  allowedEasyCare: "Allows this account category to be used with Easycare.",
};


const AccountsTypesView = ({ edit, formik, addNew }) => {
  const [disabled] = useState(true);

  const isInteractive = useMemo(
    () => !(disabled && !edit && !addNew),
    [disabled, edit, addNew]
  );

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    formik.setFieldValue(name, type === "checkbox" ? checked : value);
  };

  return (
    <>
      <div
        className="col-md-4 pl-5 ml-5 new_catagory_type"
        style={{ pointerEvents: isInteractive ? "initial" : "none" }}
      >
        <InputField
          mandatory
          formik={formik}
          name="new_catagory_type"
          title="Account Category Title"
          placeholder=""
          value={formik.values?.new_catagory_type}
          style={{ height: "48px" }}
        />
      </div>

      <div className="account-types-view d-flex flex-wrap pl-5 ml-5 mt-5 pt-5">
        {checkboxes?.map(({ name, title }) => (
          <div
            key={name}
            className="type-check-box col-md-6 col-sm-12 pl-5 mb-3"
            style={{ pointerEvents: isInteractive ? "initial" : "none", display: "flex", alignItems: "center" }}
          >
            <MyCheckbox
              name={name}
              title={title}
              handlechange={onChange}
              checked={formik.values?.[name]}
            />
            {CHECKBOX_HINTS[name] && (
              <InfoTooltip text={CHECKBOX_HINTS[name]} style={{ marginLeft: '6px', marginBottom: '8px' }} />
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default AccountsTypesView;
